import * as React from 'react'

const SvgPasteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 12.5h-5.106l1.612-1.619-.881-.881-3.125 3.125 3.125 3.125.881-.881-1.612-1.619h5.106v5h1.25v-5c0-.69-.56-1.25-1.25-1.25zm-1.431-6.694l-4.375-4.375A.625.625 0 0010 1.25H3.75c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h5V17.5h-5v-15h5v3.75c0 .69.56 1.25 1.25 1.25h3.75v1.25H15v-2.5a.625.625 0 00-.181-.444zM10 2.756l3.494 3.494H10V2.756z"
      fill="#163250"
    />
  </svg>
)

export default SvgPasteIcon
